import { z } from 'zod';
const barcodeAamvaFieldConfigurationSchema = z.object({
    enabled: z.boolean(),
});
export const barcodeAamvaDataConfigurationSchema = z.object({
    dajState: barcodeAamvaFieldConfigurationSchema,
    dbaExpirationDate: barcodeAamvaFieldConfigurationSchema,
    dbdIssueDate: barcodeAamvaFieldConfigurationSchema,
    dcfRevisionNumber: barcodeAamvaFieldConfigurationSchema,
    dcgCountry: barcodeAamvaFieldConfigurationSchema,
    dcsLastName: barcodeAamvaFieldConfigurationSchema,
    dctFirstAndMiddleName: barcodeAamvaFieldConfigurationSchema,
    zceAffiliation: barcodeAamvaFieldConfigurationSchema,
    dakZipCode: barcodeAamvaFieldConfigurationSchema,
    dayEyeColor: barcodeAamvaFieldConfigurationSchema,
    dbbDateOfBirth: barcodeAamvaFieldConfigurationSchema,
    dbcGender: barcodeAamvaFieldConfigurationSchema,
    zctOccupationTitle: barcodeAamvaFieldConfigurationSchema,
    zclAccessLevel: barcodeAamvaFieldConfigurationSchema,
    dauHeight: barcodeAamvaFieldConfigurationSchema,
    daiCity: barcodeAamvaFieldConfigurationSchema,
});
